<div class="text-center">
  <h1>
    Access Denied
  </h1>

  <p>
    Sorry, you are not authorised to access this area.
  </p>
</div>